import React from 'react';
import { Box } from '@mui/material';
import NewsDetail from '../components/news/NewsDetail';

const NewsPostDetail = () => {
  return (
    <Box>
      <NewsDetail />
    </Box>
  );
};

export default NewsPostDetail;